module.exports = __webpack_public_path__ + "img/zf.b0d135a8.png";